import { useState } from "react";
import { toastAlert } from "../../../utils/AlertContext";
import { deleteDocumentUserURL } from "../../../utils/ConstantsURL";

export const useDeleteDocumentUser = (token) => {
  const [loading, setLoading] = useState(false);

  const deleteDocument = async (documentId, userId) => {
    try {
      setLoading(true);
      const response = await fetch(deleteDocumentUserURL(userId), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ document_id: documentId }),
      });

      if (!response.ok) {
        throw new Error("Error al eliminar el documento");
      }

      const data = await response.json();
      toastAlert("Documento eliminado correctamente", "success", 3000);
      return data;
    } catch (error) {
      toastAlert("Error al eliminar el documento", "error", 3000);
    } finally {
      setLoading(false);
    }
  };

  return { deleteDocument, loading };
};
